import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next'; // Import useTranslation
import EventComment from './EventComment';

const EventCommentList = ({ event, comments, loadingComments }) => {
    const { t } = useTranslation(); 

    return (
        (event.start_time && new Date(event.start_time) < new Date()) && (
            <div style={{ marginTop: 48, width: '100%', maxWidth: 700, marginLeft: 'auto', marginRight: 'auto' }}>
            <h3>{t('eventDetails.commentsTitle', 'Commentaires')}</h3>
            {loadingComments ? (
                <div>{t('eventDetails.loadingComments', 'Chargement des commentaires...')}</div>
            ) : comments.length === 0 ? (
                <div>{t('eventDetails.noComments', 'Aucun commentaire pour cet événement.')}</div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {comments.map((comment, idx) => (
                    <EventComment commentKey={comment.id || idx} comment={comment} />
                ))}
                </div>
            )}
            </div>
        ) || (
            !event.start_time || new Date(event.start_time) >= new Date()
        ) && (
            <div style={{ marginTop: 48, width: '100%', maxWidth: 700, marginLeft: 'auto', marginRight: 'auto' }}>
            <h3>{t('eventDetails.commentsTitle', 'Commentaires')}</h3>
            <Typography variant="body2" sx={{ mb: 1, textAlign: 'center', fontSize: '0.90rem' }}>
                {t('eventDetails.commentsAfterEvent', 'Les commentaires seront disponibles une fois l\'événement passé.')}
            </Typography>
            </div>
        ))
};

EventCommentList.propTypes = {
    event: PropTypes.object.isRequired,
    comments: PropTypes.array,
    loadingComments: PropTypes.bool
};

export default EventCommentList;